import {ConverterHtml, Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalConverterHtml extends ConverterHtml implements Parameter {
	public useTemplateFile?: boolean;
	public templateContent?: string;

	constructor(data: any) {
		super(data);

		this.useTemplateFile = FunctionHelper.exists(data?.useTemplateFile) ? data.useTemplateFile : false;
		this.templateContent = FunctionHelper.exists(data?.templateContent) ? data.templateContent : false;
	}

	public static getUseTemplateFileDefault(): boolean {
		return true;
	}

	public static getTemplateContentDefault(): string {
		return "";
	}

	public static fromJson(data: any): PortalConverterHtml {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalConverterHtml(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'useTemplateFile': this.useTemplateFile,
			'templateContent': this.templateContent
		};
	}

	public clone(): PortalConverterHtml {
		return PortalConverterHtml.fromJson(this.toJson());
	}
}